<template>
  <div
    v-if="chartComponent"
    class="fill-height"
  >
    <component
      :is="chartComponent"
      :stats="stats"
      :player="player"
      :protocol-id="protocolId"
      :date="date"
      :height="height"
      :removable="removable"
      @remove="$emit('remove')"
    />
  </div>
</template>

<script>
import TsaChart from '@/components/charts/implementation/TsaChart.vue'
import CompositeDiagChart from '@/components/charts/implementation/CompositeDiagChart.vue'
import PlayerDiagnosticTrendChart from '@/components/charts/implementation/PlayerDiagnosticTrendChart.vue'
import dayjs from 'dayjs'

export default {
  name: 'DiagnosticChart',
  components: {
    TsaChart,
    CompositeDiagChart,
    PlayerDiagnosticTrendChart
  },
  props: {
    stats: {
      type: [Object, Array],
      required: true
    },
    removable: {
      type: Boolean,
      default: false
    },
    chart: {
      type: Object,
      required: true
    },
    player: {
      type: Object,
      default: () => ({})
    },
    protocolId: {
      type: Number,
      default: null
    },
    date: {
      type: Object,
      default: () => dayjs()
    },
    height: {
      type: Number,
      default: 500
    }
  },
  computed: {
    chartComponent() {
      const componentMap = {
        TSA: 'TsaChart',
        COMPOSITE_DIAG: 'CompositeDiagChart',
        DIAG_TREND: 'PlayerDiagnosticTrendChart'
      }

      return componentMap[this.chart.key] || null
    }
  }
}
</script>
